module.exports = __webpack_public_path__ + "img/8.4c2286b1.jpg";